import {NgModule} from '@angular/core';
import {ChartWidgetModule} from '../../../../widgets/chart-widget/chart-widget.module';
import {DexDevRatesWidgetModule} from '../../../../widgets/dex-dev-rates-widget/dex-dev-rates-widget.module';
import {DexDynWidgetModule} from '../../../../widgets/dex-dyn-widget/dex-dyn-widget.module';
import {DexLpCollapsedWidgetModule} from '../../../../widgets/dex-lp-collapsed-widget/dex-lp-collapsed-widget.module';
import {DexLpDetailsWidgetModule} from '../../../../widgets/dex-lp-details-widget/dex-lp-details-widget.module';
import {DexLpTradeWidgetModule} from '../../../../widgets/dex-lp-trade-widget/dex-lp-trade-widget.module';
import {DexLpWidgetModule} from '../../../../widgets/dex-lp-widget/dex-lp-widget.module';
import {
    DexTrancheDetailsWidgetModule
} from '../../../../widgets/dex-tranche-details-widget/dex-tranche-details-widget.module';
import {DexTransferWidgetModule} from '../../../../widgets/dex-transfer-widget/dex-transfer-widget.module';
import {DexTxHistoryWidgetModule} from '../../../../widgets/dex-tx-history-widget/dex-tx-history-widget.module';
import {DexWalletWidgetModule} from '../../../../widgets/dex-wallet-widget/dex-wallet-widget.module';
import {WidgetCommonModule} from './widget-common.module';

@NgModule({
    imports: [
        WidgetCommonModule,
        DexDynWidgetModule,
        DexDevRatesWidgetModule,
        DexWalletWidgetModule,
        ChartWidgetModule,
        DexLpWidgetModule,
        DexLpCollapsedWidgetModule,
        DexLpTradeWidgetModule,
        DexLpDetailsWidgetModule,
        DexTrancheDetailsWidgetModule,
        DexTxHistoryWidgetModule,
        DexTransferWidgetModule
    ],
    exports: [
        WidgetCommonModule
    ]
})
export class WidgetModule {}
